import { faFilterSlash } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PillChart } from '@repo/videa-components/src/common-charts/index';
import { chartColors } from 'node_modules/@repo/videa-components/src/common-charts/themes/colors';

import { usePreferences } from '@/react-query/usePreferences';

import { TrendIndicator } from '../components/TrendIndicator';
import { useOverallRates } from '../helpers/benchmarking/overallRates';

export const AIViewRateChart = ({
  practices,
  providers,
}: {
  practices?: string[];
  providers?: string[];
}) => {
  const viewRate = useOverallRates({
    practices,
    providers,
  });

  const { data: prefs } = usePreferences();

  if (!prefs.enableInsightsEngagementMetric) {
    return null;
  }

  return (
    <div className="vai-bg-white vai-rounded-lg vai-p-4 vai-border-gray-200 vai-border-[1px] vai-h-full vai-flex vai-flex-col vai-gap-2">
      <div className="vai-flex vai-flex-col">
        <span className="vai-typography-h4">AI Recommendation View Rate</span>
        <span className="vai-typography-muted">
          Percent of x-rays with VideaAI recommendations viewed by a user
        </span>
      </div>
      {!viewRate.isLoading && viewRate.viewedRate !== undefined && (
        <div className="vai-flex vai-flex-row vai-gap-4">
          <div className="vai-flex vai-flex-col vai-gap-2 vai-items-center vai-justify-center">
            <span className="vai-typography-h2 vai-font-semi-bold">
              {Math.round(viewRate.viewedRate * 100)}%
            </span>
            <TrendIndicator
              value={
                viewRate.viewedRate && viewRate.previousViewedRate
                  ? Math.round(
                      ((viewRate.viewedRate - viewRate.previousViewedRate) /
                        viewRate.previousViewedRate) *
                        100,
                    )
                  : undefined
              }
              suffix="%"
            />
          </div>

          <PillChart
            data={[
              {
                name: 'AI Not Viewed',
                data: 1 - viewRate.viewedRate,
                color: chartColors['chart-tint']['viz-empty'],
              },
              {
                name: 'AI Viewed',
                data: viewRate.viewedRate,
                color: chartColors.chart[1],
              },
            ]}
            chartOptions={{
              height: 70,
              yAxisMin: -1 * viewRate.viewedRate,
              yAxisMax: 1 - viewRate.viewedRate,
              tooltipFormatter: function (this: any) {
                return `${
                  this.series.userOptions.name
                }: ${Math.abs(Math.round(this.y * 100))}%`;
              },
              yAxisFormatter: function (this: any) {
                return `${Math.round((this.value + viewRate.viewedRate) * 100)}%`;
              },
            }}
          />
        </div>
      )}
      {!viewRate.isLoading && viewRate.viewedRate === undefined && (
        <div className="vai-flex vai-gap-1 vai-flex-col vai-items-center vai-justify-center vai-flex-1">
          <FontAwesomeIcon
            icon={faFilterSlash}
            className="vai-h-10 vai-w-10 vai-text-zinc-300 vai-p-2"
          />
          <span className="vai-text-lg vai-text-muted-foreground">No data</span>
          <span className="vai-typography-muted">
            Adjust your filters and try again
          </span>
        </div>
      )}
      {viewRate.isLoading && (
        <div className="vai-flex vai-p-4 vai-h-[70px] vai-w-full">
          <img
            src="/assets/images/insights/aiViewRateLoading.png"
            alt="loading"
            className="vai-w-full vai-opacity-20"
          />
        </div>
      )}
    </div>
  );
};
